export default __webpack_public_path__ + "static/media/drafts1.03a19cb1.png";